import { IApplicationState } from '../../types/redux';

export const selectUserPhone = (state: IApplicationState): string => {
  return state.userData?.phones?.[0]?.phone || '';
};
